import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Music from './views/Music.vue'
/*import Events from './views/events.vue'
import Reviews from './views/Reviews.vue'
import Coven from './views/Coven.vue'
import Gallery from './views/Gallery.vue'
import Store from './views/Store.vue'*/


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/events',
      name: 'events',
      // route level code-splitting
      // this generates a separate chunk (events.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "events" */ './views/Events.vue')
    },
    {
      path: '/music',
      name: 'music',
      component: () => import(/* webpackChunkName: "music" */ './views/Music.vue')
    },
    {
      path: '/store',
      name: 'store',
      component: () => import(/* webpackChunkName: "store" */ './views/Store.vue')
    },
    {
      path: '/press',
      name: 'press',
      component: () => import(/* webpackChunkName: "press" */ './views/Press.vue')
    }
  ]
})
